import React from "react";
import {store} from "../../Redux/store"
import { AppProvider } from "../Provider";
import { CustomConversation } from "./CustomConversation";

export const  MirrorflyConversation = (props)=>{
    const {  width = "",  height = "" , enableDeviceSize = false , sdkInitial = false} = props
    return (
    <AppProvider store={store}>
        <div id="mf-root-Parent" style={{ width: width ? width  : "100%",   height: height ? height : "100%" }}>
            <CustomConversation
                sdkInitial={sdkInitial}
                userId = {props.userId} 
                chatType={props.chatType}
                enableDeviceSize = {(width || height) ? false : enableDeviceSize}
                enableMobileView={props.enableMobileView}
                isCallEnabled={props.isCallEnabled}
            />
        </div>
    </AppProvider>
        );
}

